var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardImage2Min(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 250,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M135.424 18.21c-10.609 14.603-13.39 35.006-27.503 47.84-7.111 6.492-16.29 10.435-24.593 15.499-17.113 10.43-30.951 26.532-35.167 45.364-3.73 16.426.695 37.271 14.647 48.689 7.18 5.86 13.29 9.007 18.46 17.144 5.595 8.808 8.582 16.88 17.094 23.507 8.221 6.414 17.524 11.513 26.713 16.586 9.591 5.289 19.301 10.63 29.946 13.608 11.094 3.107 22.808 3.532 34.377 3.57 16.532.057 34.102-.952 47.639-9.954 11.91-7.913 17.56-19.98 24.027-31.787 6.467-11.808 14.062-22.074 22.018-33.129 7.549-10.431 15.222-21.161 18.053-33.5a47.144 47.144 0 0 0-.735-23.299c-1.79-6.315-1.215-13.318-4.827-18.975-5.053-7.893-11.773-14.71-19.739-20.023-7.956-5.298-16.99-8.981-25-14.205-8.011-5.224-15.241-12.552-16.871-21.641-.617-3.424-.407-6.926-.868-10.388-1.343-10.107-8.545-18.958-17.651-24.407-9.107-5.45-19.949-7.748-30.696-8.475-11.449-.792-23.292.238-33.668 4.956-6.878 3.138-11.792 7.691-15.656 13.02z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.744 90.132c-1.042-1.533-1.297-3.411-1.946-5.13-.648-1.718-1.964-3.462-3.873-3.657-1.909-.195-3.599 1.22-4.79 2.666a8.192 8.192 0 0 0-1.572 2.597c-.22.67-.29 1.377-.204 2.075.085.697.322 1.37.698 1.975.375.605.88 1.13 1.481 1.539.602.41 1.287.695 2.012.839.959.19 1.992.138 2.868.55a7.108 7.108 0 0 1 1.603 1.237c1.11.983 2.531 1.805 4.047 1.71 1.343-.087 3.083-1.38 2.69-2.818-.365-1.328-2.233-2.437-3.014-3.584z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.841 120.728v94.326s0 6.375 6.728 7.051c6.727.675 140.966 0 140.966 0s4.96.333 7.44-6.06c2.48-6.393 0-95.334 0-95.334l-155.134.017z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M94.841 120.728v94.326s0 6.375 6.728 7.051c6.727.675 140.966 0 140.966 0s4.96.333 7.44-6.06c2.48-6.393 0-95.334 0-95.334l-155.134.017z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.532 56.28-79.69 64.448 53.283 43.46c3.327 2.714 7.571 4.207 11.961 4.207h26.75c3.03.001 5.96-1.03 8.257-2.904l54.882-44.763-75.443-64.448z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.532 56.28-79.69 64.448 52.52 42.85c3.812 3.108 8.673 4.817 13.702 4.817h24.598c3.799-.001 7.473-1.292 10.353-3.64l53.96-44.027-75.443-64.448z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.063 106.349c-.022.117-.045.238-.064.355-1.073 5.704-4.298 10.844-9.074 14.461-2.617 1.969-5.764 3.541-7.349 6.328-.995 1.731-1.251 3.77-1.452 5.752-1.187 11.583-1.694 22.905-.361 34.475l-3.653.675h-15.021c-1.453 0-5.979.368-10.021.359h-.022c-3.197 0-6.125-.277-6.92-1.16a.558.558 0 0 1-.073-.095.884.884 0 0 1-.096-.147c-.036-.061-.077-.121-.114-.191-.036-.069-.082-.155-.123-.238l-.041-.078c-1.069-2.294-.973-6.271-1.22-8.505-.347-3.177-.566-6.375-.94-9.552-.777-6.436-2.33-13.041-6.481-18.179-.598-.736-1.694-1.891-3.083-3.281-4.932-4.938-13.587-12.846-16.898-15.612-.534-.432-19.273-14.157-19.442-14.806-.456-1.879 5.056-4.402 5.937-6.134 6.166 3.36 30.504 19.949 36.66 23.312 2.987 1.628 6.02 3.277 9.367 4.06 7.038 1.649 14.359-.723 21.182-3.064 4.681-1.606 10.934-4.06 15.852-6.925 2.124-1.234 5.358-3.653 2.343-3.541-5.06.186-10.477-.173-14.646.03-.217.043-.441.04-.657-.008a1.548 1.548 0 0 1-.59-.273 1.312 1.312 0 0 1-.238-1.017c.188-3.489-.424-3.584.727-6.904 4.448 1.04 9.764.122 14.34.174 4.901.051 6.947-.628 10.071 2.54a8.021 8.021 0 0 1 1.899 2.757c.548 1.403.443 2.952.201 4.432z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42 118.629c1.187 1.835.854 3.03 2.64 4.359.84.627 4.411 1.298 5.809.294 1.745-1.268 1.539-4.887 1.571-5.133a2.319 2.319 0 0 0-.283-1.178 34.734 34.734 0 0 1-1.526-3.653 6.72 6.72 0 0 1-.178-3.895 3.972 3.972 0 0 0-1.341-.818 4.137 4.137 0 0 0-1.572-.247 6.49 6.49 0 0 0-2.827 1.06c-.654.433-2.686-2.666-3.106-2.034-.365.571.781 9.734.813 11.245z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.493 105.722s1.909 8.908 5.608 10.938c3.699 2.03 5.289.796 5.289.796l-2.814-6.756-8.083-4.978z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 113.4c.754.093 1.52.045 2.256-.138 1.827-.567 2.703-2.701 2.475-4.761-.228-2.061-1.334-4.047-2.557-5.856a41.695 41.695 0 0 0-5.23-6.307 13.88 13.88 0 0 0-3.653-2.804 7.581 7.581 0 0 0-5.906-.307c-1.809.73-3.282 2.053-4.151 3.726a8.547 8.547 0 0 0-.996 5.54c1.238 7.319 12.044 10.47 17.762 10.907z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.185 101.45c-.644.376-1.494.207-2.161-.13a4.204 4.204 0 0 1-2.087-2.329 3.503 3.503 0 0 1 .37-3.03c.457-.666 1.133-1.22 1.279-1.99 0 0 5.362-4.026 6.307-9.73.945-5.705 7.084-.433 7.084-.433s6.795 5.717 3.589 9.236c-.32.326-.724.566-1.173.697-.449.13-.927.147-1.384.048-1.37-.251-4.07-.052-7.956 3.406l-3.868 4.255z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.053 97.195a4.603 4.603 0 0 0-2.078.204 3.851 3.851 0 0 0-1.644 1.64 3.368 3.368 0 0 0-.594 1.623c-.023.775.416 1.485.845 2.143.236.443.58.826 1.005 1.116.447.216.941.333 1.443.342.822.078 1.713.134 2.416-.281.268-.21.556-.396.858-.558.864-.338 2.028.316 2.704-.29.284-.334.427-.755.402-1.182l.169-2.515c.05-.71.379-1.454-.416-1.71-1.456-.467-3.571-.532-5.11-.532z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.309 102.268s5.316 5.146 6.85 5.146c1.535 0-2.128 4.926-3.895 4.03-1.768-.896-5.234-7.181-5.234-7.181s.982-1.939 1.484-2.107a.792.792 0 0 1 .795.112z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.365 92.248c1.202-.948.208-3.96-2.22-6.728-2.429-2.768-5.372-4.244-6.575-3.297-1.202.948-.208 3.96 2.22 6.728 2.429 2.769 5.372 4.245 6.575 3.297z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.365 92.248c1.202-.948.208-3.96-2.22-6.728-2.429-2.768-5.372-4.244-6.575-3.297-1.202.948-.208 3.96 2.22 6.728 2.429 2.769 5.372 4.245 6.575 3.297z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.771 92.01c-.419 1.57-1.369 2.967-2.703 3.978-.768.619-1.626 1.138-2.38 1.774a4.84 4.84 0 0 0-1.68 2.338 4.435 4.435 0 0 0 .689 3.384 26.21 26.21 0 0 0 2.229 2.822c.109.098.19.221.237.356a.818.818 0 0 1 .032.419c-.114.303-.525.39-.863.368a2.776 2.776 0 0 1-1.164-.338 1.681 1.681 0 0 0-.635-.264.809.809 0 0 0-.523.221.722.722 0 0 0-.226.498c-.001.378.136.745.388 1.039.399.524.914.959 1.508 1.276a4.878 4.878 0 0 0 1.936.554.486.486 0 0 1-.181.534.549.549 0 0 1-.185.09 1.506 1.506 0 0 1-.836-.052 26.497 26.497 0 0 1-2.082-.68l-2.654-.948c-1.059-.372-2.119-.744-3.16-1.155a5.623 5.623 0 0 1-2.165-1.273c-.653-.71-.913-1.679-1.059-2.597a5.339 5.339 0 0 1 .027-2.735c.292-.831.959-1.545 1.028-2.415.068-.87-.521-1.732-.964-2.528-.512-.935-.845-2.034-.512-3.03a3.42 3.42 0 0 1 1.667-1.826 7.672 7.672 0 0 1 2.467-.758c.749-.125 1.557-.225 2.128-.705 1.306-1.091.616-3.463 1.991-4.458 1.466-1.078 3.818.285 5.184 1a4.686 4.686 0 0 1 2.157 2.154 4.35 4.35 0 0 1 .304 2.957z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.569 222.105 42.14-43.768c3.015-3.134 6.687-5.639 10.78-7.353a33.719 33.719 0 0 1 12.996-2.602h9.714c4.512.001 8.974.9 13.096 2.639 4.122 1.74 7.812 4.281 10.831 7.459l41.409 43.612-140.966.013z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.569 222.104 41.948-43.568c3.077-3.195 6.822-5.746 10.998-7.493a34.38 34.38 0 0 1 13.253-2.648h9.134c4.603 0 9.154.918 13.359 2.692 4.204 1.775 7.968 4.367 11.048 7.609l41.217 43.408H101.569z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.394 77.09c.002 3.927-1.206 7.768-3.478 11.052-2.271 3.284-5.505 5.867-9.305 7.431a22.328 22.328 0 0 1-12.082 1.375c-4.083-.668-7.87-2.452-10.897-5.134-3.026-2.68-5.16-6.142-6.138-9.957a19.149 19.149 0 0 1 .632-11.517c1.391-3.698 3.893-6.93 7.197-9.3 3.304-2.368 7.266-3.77 11.4-4.033V77.09h22.671z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.696 74.753h-22.671V54.65a22.28 22.28 0 0 1 9.552 1.486 21.377 21.377 0 0 1 6.897 4.37 20.108 20.108 0 0 1 4.606 6.537 19.23 19.23 0 0 1 1.616 7.711z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.696 74.753h-22.671V54.65a22.28 22.28 0 0 1 9.552 1.486 21.377 21.377 0 0 1 6.897 4.37 20.108 20.108 0 0 1 4.606 6.537 19.23 19.23 0 0 1 1.616 7.711z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.262 110.661H273.29c-3.226 0-5.841 2.478-5.841 5.535v12.648c0 3.057 2.615 5.535 5.841 5.535h23.972c3.226 0 5.842-2.478 5.842-5.535v-12.648c0-3.057-2.616-5.535-5.842-5.535z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.369 117.599v10.517l12.28-5.929-12.28-4.588z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.543 81.877-.356 5.12-4.868 2.684 5.311 2.52.535 5.535 4.868-5.116 5.403.502-2.571-3.778.977-5.454-5.047 1.93-4.252-3.943zM107.588 46.295l-.352 5.12-4.873 2.684 5.316 2.519.53 5.536 4.869-5.116 5.402.502-2.566-3.774.973-5.458-5.047 1.93-4.252-3.943zM57.296 74.238h-4.96v15.106h4.96V74.238zM64.288 80.254h-4.96v9.09h4.96v-9.09zM71.284 76.909h-4.96v12.435h4.96V76.909z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.877 72.563-2.836 4.865M194.81 77.095l-5.225 3.523M198.705 83.302l-6.553 1.68",
    stroke: "#fff",
    strokeWidth: 2.188,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.676 168.17c-1.19.257-2.395.452-3.608.584h-.022c-2.581.273-5.782.273-6.92-1.16a.49.49 0 0 1-.073-.095.884.884 0 0 1-.096-.147c-.036-.06-.077-.121-.114-.19-.036-.07-.082-.156-.123-.238l-.041-.078c-1.069-2.294-.973-6.272-1.22-8.505-.347-3.177-.566-6.376-.94-9.553-.777-6.436-2.33-13.041-6.481-18.178-.598-.736-3.115-3.463-4.503-4.835l1.95.783s15.345 6.263 16.761 12.085c1.416 5.821 5.43 29.527 5.43 29.527z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 106.704c-1.073 5.704-4.298 10.844-9.074 14.461-2.617 1.969-5.764 3.541-7.349 6.328-.995 1.731-1.251 3.77-1.452 5.752 0 0 .498-9.466 4.042-12.599 3.544-3.134 12.788-12.448 13.486-16.699.197.909.313 1.831.347 2.757z",
    fill: "url(#n)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 184.131,
    y1: 86.472,
    x2: 176.962,
    y2: 91.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 97.326,
    y1: 88.933,
    x2: 112.813,
    y2: 88.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 173.778,
    y1: 81.155,
    x2: 169.331,
    y2: 224.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 158.561,
    y1: 113.689,
    x2: 172.12,
    y2: 118.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 168.165,
    y1: 110.363,
    x2: 143.768,
    y2: 125.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 151.991,
    y1: 108.07,
    x2: 167.947,
    y2: 99.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 172.732,
    y1: 100.744,
    x2: 182.689,
    y2: 100.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 147.408,
    y1: 230.488,
    x2: 175.447,
    y2: 152.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 174.189,
    y1: 218.213,
    x2: 252.889,
    y2: 58.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 274.646,
    y1: 59.077,
    x2: 197.862,
    y2: 90.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 290.526,
    y1: 107.96,
    x2: 266.007,
    y2: 172.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 176.496,
    y1: 141.763,
    x2: 39.221,
    y2: 176.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 200.395,
    y1: 110.292,
    x2: 199.218,
    y2: 148.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h350v250H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage2Min);
export default __webpack_public_path__ + "static/media/Card Image 2-min.f3c402f0806830de8ec20ab20bc973d3.svg";
export { ForwardRef as ReactComponent };